import React from 'react'
import Footer from './Footer'
import Navbar from './Navbar'

export default function Work() {
  return (
    <div>
      <Navbar/>

     <div className="container work projects">
     <h1>PROJECTS </h1>

     <table className="table table-hover ptable">
     <thead>
     <tr>
      <th scope="col">Title</th>
      <th scope="col">Description</th>
      <th scope="col">Year</th>
      <th scope="col">Link</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>Sojourn</td>
      <td>Find more about the places you crave to see, or  discover the ones you would love to </td>
      <td>2023</td>
      <td><a href="https://sojourn-fbmkb2ecngwii6afg7uwsc.streamlit.app/" target='_blank'>Go to app</a></td>
    </tr>
    <tr>
      <td>i-Notes</td>
      <td>Note making made easy- take notes on the go and access them anytime</td>
      <td>2023</td>
      <td><a href="https://github.com/JA-26-01/iNotes" target='_blank'>View on Github</a></td>
    </tr>
    <tr>
      <td>Women Safety Night Patrolling Robot</td>
      <td>Arduino Based Robot, enabled with object avoidance and 24 x 7 video surveillance</td>
      <td>2023</td>
      <td><a href="https://drive.google.com/drive/folders/1PHE7wW7GTSDm173qwRbUof1J3YRYnwIG?usp=sharing" target='_blank'>See Documentation</a></td>
    </tr>
    <tr>
      <td>First Today</td>
      <td>Get the latest news ranging from sports to business to health- all in one place</td>
      <td>2023</td>
      <td><a href="https://github.com/JA-26-01/First-Today" target='_blank'>View on Github</a></td>
    </tr>
    <tr>
      <td>Text-Mani</td>
      <td>A simple text manipulation tool</td>
      <td>2023</td>
      <td><a href="https://github.com/JA-26-01/Text-mani.app" target='_blank'>View on Github</a>&nbsp;&nbsp;<a href="https://ja-26-01.github.io/Text-mani.app/" target='_blank'>Use it</a></td>
    </tr>
    <tr>
      <td>School_access</td>
      <td>A management system for the students and teachers alike</td>
      <td>2022</td>
      <td><a href="https://github.com/JA-26-01/sms_dit_intern" target='_blank'>View on Github</a></td>
    </tr>
    <tr>
      <td>J's Ensemble</td>
      <td>An e-commerce website to help you keep up with the latest trends</td>
      <td>2021</td>
      <td><a href="https://www.behance.net/gallery/164085455/E-Commerce-Website" target='_blank'>See on Behance</a></td>
    </tr>
  </tbody>
     </table>  
     
    </div>
     <div className="container work publications">
      <h1>PUBLICATIONS</h1>
      
    <div className="pencil">
    <div className="eraser"></div>
    <div className="body2"></div>
    <div className="body1"></div>
    <div className="nib"></div>
    </div>
    <div className="writing">Work in Progress</div>
    {/* <table className="table table-hover ptable">
     <thead>
     <tr>
      <th scope="col">Title</th>
      <th scope="col">Type</th>
      <th scope="col">Year</th>
      <th scope="col">Link</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>SIFT Inspired deep learning based grading of hepatocellular carcinoma on histopathological images</td>
      <td>Research Paper</td>
      <td>2023</td>
      <td>in progress</td>
    </tr>
    <tr>
      <td>Feature importance in Federated Learning using deep neural network </td>
      <td>Conference Paper</td>
      <td>2023</td>
      <td>in progress</td>
    </tr>
    <tr>
      <td>Classification of endometrial cancer using Pipelle Biopsies</td>
      <td>Research Paper</td>
      <td>2023</td>
      <td><a href="https://github.com/JA-26-01/First-Today" target='_blank'>View on Github</a></td>
    </tr>
  </tbody>
     </table>   */}
     
      
     </div>
     
     
    <Footer/>
  </div>
  )
}
